export default __webpack_public_path__ + "static/media/AddCollaborator.fefadf60.svg";